<template>
  <v-container>
    <profile />
    <v-layout justify-center>
      <v-flex>
        <v-card>
          <v-app-bar dark color="primary">
            <h3>{{$t('activities.headline')}}</h3>
            <template v-if="description" v-slot:extension>
              <p>{{ description }}</p>
            </template>
          </v-app-bar>
          <activity-feed />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import ActivityFeed from "../components/ActivityFeed";
  import Profile from '@/components/profile/Profile'

  export default {
    name: 'Activities',
    components: {
      ActivityFeed,
      Profile
    },
    data() {
      return {
      };
    },
    computed: {
      description() {
        return this.$t('activities.description')
      }
    },
  };
</script>
